import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'

import { deleteAssortmentItem } from '../api/deleteAssortmentItem'
import { REQUEST_DELETE_ASSORTMENT_ITEM } from '../constants'

export const requestRemoveAssortmentItem = createAsyncThunk(
  REQUEST_DELETE_ASSORTMENT_ITEM,
  async (entryId: number) => {
    const isDeleted = await deleteAssortmentItem(entryId)
    return isDeleted ? entryId : null
  }
)
